// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__nr-a_","name":"ConsentHeader_name__2NPyh","birthday":"ConsentHeader_birthday__2WvsI","skeleton":"ConsentHeader_skeleton__1l-1F"};